import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/components';

import { useUser } from '@util/providers/AuthProvider';

export default function SignedOutElsewhere({ isOpen, toggle }) {
  const { t } = useTranslation();
  const { signIn } = useUser();

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {t('account.signedOutElsewhereTitle')}
      </ModalHeader>
      <ModalBody>{t('account.signedOutElsewhereMessage')}</ModalBody>
      <ModalFooter>
        <button
          className="inline-block cursor-pointer select-none rounded border text-center align-middle leading-normal font-normal transition-colors duration-150 ease-in-out focus:outline-none disabled:pointer-events-none disabled:opacity-65 px-5 py-2.5 text-base border-primary bg-primary text-white hover:border-primary-hover hover:bg-primary-hover"
          id="SignedOutElsewhereLogIn"
          onClick={() => {
            toggle();
            signIn();
          }}
        >
          {t('account.logIn')}
        </button>
        <button
          type="button"
          className="inline-block cursor-pointer select-none rounded border text-center align-middle leading-normal font-normal transition-colors duration-150 ease-in-out focus:outline-none disabled:pointer-events-none disabled:opacity-65 px-5 py-2.5 text-base border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-white"
          id="SignedOutElsewhereDismiss"
          onClick={toggle}
        >
          {t('account.signedOutElsewhereDismiss')}
        </button>
      </ModalFooter>
    </Modal>
  );
}
